import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput } from 'components';
import browserHistory from 'common/history';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const UsersToolbar = props => {
  const { className, selectedUser = [], handleSearch, ...rest } = props;

  const classes = useStyles();
  const [value, setValue] = useState('');

  const handleChange = ev => {
    setValue(ev.target.value.trim());
  }

  const handleKeyUp = ev => {
    if (ev.key === 'Enter') {
      handleSearch(value);
    }
  }

  const createOrder = ev => {
    const [ userId ] = selectedUser;
    if (userId) {
      browserHistory.push(`/createOrder/${userId}`)
    }
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button className={classes.importButton}>Import</Button>
        <Button className={classes.exportButton}>Export</Button>
        <Button
          color="primary"
          variant="contained"
        >
          Add user
        </Button>
      </div>
      <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search user"
          onChange={handleChange}
          onKeyUp={handleKeyUp}
        />
        <Button
          color="primary"
          variant="contained"
          disabled={selectedUser.length !== 1}
          onClick={createOrder}
        >
          创建订单
        </Button>
      </div>
    </div>
  );
};

UsersToolbar.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func
};

export default UsersToolbar;
